import api from './api';

export const crearEvento = (body) =>
  api.post('/api/evento_evaluacion/', body);

export const dispararWebhook = (body) =>
  api.post('/api/evento_evaluacion/webhook', body);
